module.exports = __webpack_public_path__ + "static/media/preload-widget.12e692de.gif";